module.exports = __webpack_public_path__ + "img/flow_Off.06ea3985.png";